// «الفلوس دي راحت لحساب مين؟» (0130) — قرار المالك 26/09/2026: «اسم الدافع دى ملهاش لازمه وكذلك حساب / عنوان
// instapay وحط مكانه Drop list يسال البياع التحويله دى راحت لحساب مين … بحيث يرفع سكرين التحويل ويختار الفلوس
// دى راحت لمين». القائمة من الخادم (`/lookups` ← `payment_destinations`) تُقرأ مرّةً وتُحفظ.
import { useEffect, useState } from 'react';
import { get, type LookupOption, type Lookups } from '../../lib/api.ts';

/** الطرق التي يُحوَّل فيها مال — عليها وحدها يُسأل (والخادم يلزمه). الكاش والفيزا والتقسيط في المكتب. */
export const TRANSFER_METHODS = ['INSTAPAY', 'WALLET', 'BANK_TRANSFER_SAR', 'BANK_TRANSFER_USD'] as const;
export const needsDestination = (method: string): boolean => (TRANSFER_METHODS as readonly string[]).includes(method);
export const DESTINATION_LABEL = 'الفلوس دي راحت لحساب مين؟';

let loading: Promise<LookupOption[]> | null = null;

/** قائمة الحسابات — ممّا في يد الشاشة إن وُجد، وإلّا من الخادم مرّةً واحدة للجلسة. */
export function usePaymentDestinations(given?: LookupOption[]): LookupOption[] {
  const [list, setList] = useState<LookupOption[]>(given ?? []);
  useEffect(() => {
    if (given?.length) { setList(given); return; }
    let alive = true;
    loading ??= get<Lookups>('/lookups').then(l => l.paymentDestinations ?? []).catch(() => { loading = null; return []; });
    void loading.then(d => { if (alive) setList(d); });
    return () => { alive = false; };
  }, [given]);
  return list;
}
